<template>
  <div class="m-card-actions">
    <slot />
  </div>
</template>

<style scoped>
.m-card-actions {
  display: flex;
  align-items: center;
  gap: var(--m-space-2);
  padding: var(--m-space-2) var(--m-space-4);
}
</style>
